import { useState, useEffect, useCallback } from 'react';
import { pbLog } from '../utils/log';
const log = pbLog('components:OrderListTable');

export function useTableHeight(tableWrapper) {
  const [tableHeight, setTableHeight] = useState('auto');
  const tableHeightResponse = useCallback(tableWrapper => {
    if (window.innerWidth < 600) {
      const el = tableWrapper.current;
      if (el) {
        const rect = el.getBoundingClientRect();
        if (rect && rect.top) {
          const tableHeight = `calc(100vh - ${rect.top + 20}px)`;
          log('Table height', tableHeight);
          if (tableHeight !== this.state.tableHeight) {
            return tableHeight;
          } else {
            return 'auto';
          }
        } else {
          return 'auto';
        }
      } else {
        return 'auto';
      }
    } else {
      return 'auto';
    }
  }, []);

  useEffect(
    useCallback(() => {
      setTableHeight(tableHeightResponse);
    }, [tableHeightResponse]),
    [tableHeightResponse, tableWrapper]
  );
  return [tableHeight];
}
